<template>
  <div class="event-trends">
    <div class="event-trends-title">事件热度趋势</div>
    <div class="body" v-loading="isLoading">
      <line-chart :data="trendData" v-if="trendData"></line-chart>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import LineChart from '@/components/common/EventTrendLineChart';

export default {
  props: {
    eventId: {
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      trendData: null
    };
  },
  mounted() {
    this.isLoading = true;
    QuestionQuery.getEventTrendData(this.eventId).then(res => {
      this.isLoading = false;
      this.trendData = res;
    });
  },
  components: {
    LineChart
  }
};
</script>

<style lang="scss" scoped>
.event-trends {
  overflow: hidden;
  background-color: #ffffff;
  .event-trends-title {
    margin-left: 24px;
    color: #171f46;
    font-size: 14px;
  }
  .body {
    width: 100%;
    height: 206px;
  }
}
</style>
